import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Icon } from '@/theme';

export interface DomainLiveCardProps {
  domain: string;
  appHost: string;
  brandHref: string | null;
  disabled?: boolean;
  verifying?: boolean;
  onVerify: () => Promise<void>;
}

export function DomainLiveCard({
  domain,
  appHost,
  brandHref,
  disabled,
  verifying,
  onVerify,
}: DomainLiveCardProps) {
  const { t } = useTranslation();
  return (
    <Paper variant="outlined" sx={{ p: 3, borderTop: 3, borderTopColor: 'success.main' }}>
      <Stack spacing={1.5}>
        <Typography variant="h3" component="h2">
          {t('domain.live', { domain })}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', maxWidth: 620 }}>
          {t('domain.liveBody', { appHost })}
        </Typography>
        <Box sx={{ display: 'flex', gap: 1.25, flexWrap: 'wrap', pt: 1 }}>
          {brandHref ? (
            <Button
              variant="contained"
              href={brandHref}
              target="_blank"
              rel="noopener"
              endIcon={<Icon name="open_in_new" />}
            >
              {t('domain.openBranding')}
            </Button>
          ) : null}
          {disabled ? null : (
            <Button variant="outlined" onClick={() => void onVerify()} disabled={verifying}>
              {t('domain.records.recheck')}
            </Button>
          )}
        </Box>
      </Stack>
    </Paper>
  );
}
